import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Card, ListGroup, Badge } from "react-bootstrap";
import { FiShoppingBag, FiCalendar, FiArrowUpRight, FiUsers } from "react-icons/fi";

const InfoOrdiniDettagliato = () => {
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((json) => {
        setRawData(json?.ORDINI_URGENTI?.flat() || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore statistiche:", err);
        setLoading(false);
      });
  }, []);

  // Calcolo dei dati memorizzato per performance
const stats = useMemo(() => {
    const adesso = new Date();
    
    // Otteniamo la data di oggi in formato YYYY-MM-DD usando l'ora LOCALE e non UTC
    const offset = adesso.getTimezoneOffset() * 60000;
    const oggiLocale = new Date(adesso - offset).toISOString().split('T')[0];

    const unaSettimanaFa = new Date();
    unaSettimanaFa.setDate(adesso.getDate() - 7);
    unaSettimanaFa.setHours(0, 0, 0, 0);

    const mapOggi = {};
    const mapSettimana = {};
    let totaleOggi = 0;
    let totaleSettimana = 0;

    rawData.forEach(item => {
      if (item["Tipo Riga"] === "T") {
        const importo = parseFloat(item["Importo"]) || 0;
        const fornitore = item["Ragione sociale"] || "Sconosciuto";
        
        // Pulizia della data dal JSON
        // Se la data è "2026-05-13 10:30:00", split prendera "2026-05-13"
        const dataDocStr = item["Data Ordine"]?.split(" ")[0]; 
        const dataDoc = new Date(dataDocStr);

        // Debug opzionale: decommenta la riga sotto per vedere cosa confronta il browser
        // console.log(`Confronto: ${dataDocStr} === ${oggiLocale}`);

        if (dataDocStr === oggiLocale) {
          totaleOggi += importo;
          mapOggi[fornitore] = (mapOggi[fornitore] || 0) + importo;
        }

        if (dataDoc >= unaSettimanaFa && dataDoc <= adesso) {
          totaleSettimana += importo;
          mapSettimana[fornitore] = (mapSettimana[fornitore] || 0) + importo;
        }
      }
    });

    const formatLista = (obj) =>
      Object.entries(obj)
        .map(([nome, valore]) => ({ nome, valore }))
        .sort((a, b) => b.valore - a.valore);

    return {
      oggi: totaleOggi,
      listaOggi: formatLista(mapOggi),
      settimana: totaleSettimana,
      listaSettimana: formatLista(mapSettimana)
    };
  }, [rawData]);
// Sostituisci la tua funzione attuale con questa:
const formatEuro = (value) => 
  new Intl.NumberFormat('it-IT', { 
    style: 'currency', 
    currency: 'EUR', 
    minimumFractionDigits: 2, // Forza la presenza di 2 decimali (es. ,00)
    maximumFractionDigits: 2  // Arrotonda al massimo a 2 decimali
  }).format(value);

  const RenderLista = ({ lista, color }) => (
    <div className="custom-scroll" style={{ height: "160px", overflowY: "auto" }}>
      <ListGroup variant="flush" className="bg-transparent">
        {lista.length > 0 ? lista.map((f, i) => (
          <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center px-0 py-2 border-bottom border-secondary border-opacity-25 bg-transparent">
            <div className="d-flex align-items-center overflow-hidden">
              <div className={`me-2 rounded-circle bg-${color}`} style={{ width: '4px', height: '4px', flexShrink: 0 }} />
              <small className="text-secondary text-truncate" style={{ fontSize: '0.7rem' }}>{f.nome}</small>
            </div>
            <span className="fw-bold text-white small ms-2">{formatEuro(f.valore)}</span>
          </ListGroup.Item>
        )) : <div className="text-muted p-2 small italic">Nessun ordine registrato</div>}
      </ListGroup>
    </div>
  );

  return (
    <Card className="border-0 card shadow-lg" style={{ 
      background: "linear-gradient(145deg, #1e1e1e 0%, #121212 100%)", 
      borderRadius: "16px",
      overflow: "hidden" ,
      height: "350px",
    }}>
      <style>{`
        .custom-scroll::-webkit-scrollbar { width: 4px; }
        .custom-scroll::-webkit-scrollbar-track { background: transparent; }
        .custom-scroll::-webkit-scrollbar-thumb { background: #444; border-radius: 10px; }
        .stat-card { transition: transform 0.3s ease; }
        .stat-card:hover { transform: translateY(-5px); }
        .icon-box { background: rgba(255,255,255,0.05); backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.1); }
      `}</style>

      <div className="p-3 border-bottom border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
        <span style={{ fontWeight: "800", fontSize: "0.7rem", color: "#888", letterSpacing: "1.5px" }}>
          ANALISI ACQUISTI
        </span>
        <Badge bg="danger" className="p-1 px-2" style={{ fontSize: '0.6rem' }}>LIVE REPORT</Badge>
      </div>

      <Card.Body className="p-0 ">
        <Row className="g-0">
          {/* Sezione OGGI */}
          <Col xs={6} className="p-4 border-end border-secondary border-opacity-25 stat-card">
            <div className="d-flex align-items-center mb-4">
              <div className="icon-box text-danger p-2 rounded-3 me-3 d-flex align-items-center justify-content-center" style={{width: "42px", height: "42px"}}>
                <FiShoppingBag size={20} />
              </div>
              <div>
                <small className="text-uppercase text-secondary fw-bold" style={{ fontSize: "0.6rem", letterSpacing: '0.5px' }}>Acquistato Oggi</small>
                <h3 className="mb-0 fw-bold text-white" style={{ letterSpacing: '-1px' }}>{loading ? "..." : formatEuro(stats.oggi)}</h3>
              </div>
            </div>
            
            <div className="mb-2 d-flex align-items-center text-secondary" style={{ fontSize: "0.65rem", fontWeight: '700' }}>
              <FiUsers className="me-1 text-danger"/> TOP FORNITORI DEL GIORNO
            </div>
            <RenderLista lista={stats.listaOggi} color="danger" />
          </Col>

          {/* Sezione SETTIMANA */}
          <Col xs={6} className="p-4 stat-card">
            <div className="d-flex align-items-center mb-4">
              <div className="icon-box text-info p-2 rounded-3 me-3 d-flex align-items-center justify-content-center" style={{width: "42px", height: "42px"}}>
                <FiCalendar size={20} />
              </div>
              <div>
                <small className="text-uppercase text-secondary fw-bold" style={{ fontSize: "0.6rem", letterSpacing: '0.5px' }}>Ultimi 7 Giorni</small>
                <h3 className="mb-0 fw-bold text-white" style={{ letterSpacing: '-1px' }}>{loading ? "..." : formatEuro(stats.settimana)}</h3>
              </div>
            </div>

            <div className="mb-2 d-flex align-items-center text-secondary" style={{ fontSize: "0.65rem", fontWeight: '700' }}>
              <FiArrowUpRight className="me-1 text-info"/> TREND SETTIMANALE
            </div>
            <RenderLista lista={stats.listaSettimana} color="info" />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default InfoOrdiniDettagliato;